var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        {
          ref: "truckSettlement",
          staticClass: "waybill-form",
          attrs: { model: _vm.model, rules: _vm.rules, "label-width": "120px" },
        },
        [
          _c(
            "q-form-item",
            { attrs: { label: "سال", prop: "year" } },
            [
              _c("q-input-number", {
                model: {
                  value: _vm.model.year,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "year", $$v)
                  },
                  expression: "model.year",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-form-item",
            { attrs: { label: "ماه", prop: "month" } },
            [
              _c("q-input-number", {
                model: {
                  value: _vm.model.month,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "month", $$v)
                  },
                  expression: "model.month",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-form-item",
            { attrs: { label: "نفتکش", prop: "truck" } },
            [
              _c("q-model-selector", {
                staticStyle: { width: "100%" },
                attrs: {
                  plugin: "gama",
                  delegate: "getTrucks",
                  "display-field": "title",
                  "value-field": "id",
                  placeholder: "نفتکش را انتخاب کنید",
                },
                model: {
                  value: _vm.model.truck,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "truck", $$v)
                  },
                  expression: "model.truck",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-form-item",
            { attrs: { label: "مبلغ اجاره تانکر", prop: "tankerRentAmount" } },
            [
              _c("q-money", {
                model: {
                  value: _vm.model.tankerRent,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "tankerRent", $$v)
                  },
                  expression: "model.tankerRent",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-form-item",
            { attrs: { label: "دارسی (احمد این باشه؟)", prop: "darsiAmount" } },
            [
              _c("q-money", {
                model: {
                  value: _vm.model.darsiAmount,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "darsiAmount", $$v)
                  },
                  expression: "model.darsiAmount",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-form-item",
            { attrs: { prop: "debtorTranslate" } },
            [
              _c(
                "q-checkbox",
                {
                  model: {
                    value: _vm.model.translateDebtor,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "translateDebtor", $$v)
                    },
                    expression: "model.translateDebtor",
                  },
                },
                [_c("span", [_vm._v("بدهکاری منتقل شود")])]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-form-item",
            { attrs: { prop: "creditorTranslate" } },
            [
              _c(
                "q-checkbox",
                {
                  model: {
                    value: _vm.model.translateCreditor,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "translateCreditor", $$v)
                    },
                    expression: "model.translateCreditor",
                  },
                },
                [_c("span", [_vm._v("بستانکاری منتقل شود")])]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-form-item",
            { attrs: { prop: "summerySettlement" } },
            [
              _c(
                "q-checkbox",
                {
                  model: {
                    value: _vm.model.justShowExpenseList,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "justShowExpenseList", $$v)
                    },
                    expression: "model.justShowExpenseList",
                  },
                },
                [_c("span", [_vm._v("خلاصه هزینه ها")])]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-form-item",
            [
              _c(
                "q-button",
                {
                  staticClass: "persist-button",
                  attrs: { type: "primary" },
                  on: { click: _vm.addSettlement },
                },
                [_c("span", [_vm._v("چاپ کن")])]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }